/**
 * Regular expression matching standard LRC timestamps (e.g., [00:12.34], [01:23.456], [120:00.00]).
 */
export const TS_REGEX = /(\[\d{1,3}:\d{2}(?:\.\d{1,3})?\])/g;

/**
 * Unicode whitespace characters commonly found in copy-pasted lyrics from web lyric aggregators.
 */
export const UNICODE_SPACES_REGEX = /[\u00A0\u2000-\u200B\u2028-\u202F\uFEFF]/g;

/**
 * Escaped unicode literal representation (e.g. `\u2005`).
 */
export const ESCAPED_UNICODE_REGEX = /\\u[0-9a-fA-F]{4}/g;

/**
 * Consecutive whitespace sequence.
 */
export const MULTIPLE_SPACES_REGEX = /\s+/g;

/**
 * Characters commonly used for musical symbols, emojis, and decorative instrumental pauses.
 */
export const MUSICAL_SIGNS_REGEX = /^[♪♫♩♬♭♮♯🎵🎶🎸🎹🎷🎺🎻✨—─\-\s~_()\[\]*]+$/;

/**
 * Standard tags indicating instrumental/music interludes without vocal lyrics.
 */
export const INSTRUMENTAL_TAG_REGEX =
  /^(\[|\(|\s)*(instrumental|music|interlude|solo|intro|outro|break|(?:guitar|piano|drum|flute|violin|sax)?\s*solo|instrumental\s*break|music\s*break)(\]|\)|\s)*$/i;

/**
 * Regular expression to extract song title from LRC metadata tag: [ti:Song Title].
 */
export const TITLE_TAG_REGEX = /\[ti:\s*([^\]\r\n]+)\]/i;
